import { MagicLinkLoginPage } from './MagicLinkLoginPage';

export function ParticipantLoginPage() {
  return <MagicLinkLoginPage persona="participant" />;
}

export default ParticipantLoginPage;
